import DateRangeInput from "components/customInputs/DateRangeInput";

type DateRangeFiltersProps = {
  receivedDateAfter: string;
  receivedDateBefore: string;
  collectedDateAfter: string;
  collectedDateBefore: string;
  accessionCompletedAfter: string;
  accessionCompletedBefore: string;
  finalizedAtAfter: string;
  finalizedAtBefore: string;

  onChangeDateRange: Function;
};
const DateRangeFilters = (props: DateRangeFiltersProps) => {
  return (
    <>
      <DateRangeInput
        id="case_receivedDate"
        label="Date Received"
        values={{
          from: {
            id: "receivedDateAfter",
            name: "received_date_after",
            value: props.receivedDateAfter,
          },
          to: {
            id: "receivedDateBefore",
            name: "received_date_before",
            value: props.receivedDateBefore,
          },
        }}
        onChangeDate={props.onChangeDateRange}
        isClearable
      />
      <DateRangeInput
        id="case_collectedDate"
        label="Date Collected"
        values={{
          from: {
            id: "collectedDateAfter",
            name: "collected_date_after",
            value: props.collectedDateAfter,
          },
          to: {
            id: "collectedDateBefore",
            name: "collected_date_before",
            value: props.collectedDateBefore,
          },
        }}
        onChangeDate={props.onChangeDateRange}
        isClearable
      />
      <DateRangeInput
        id="accessionCompleted"
        label="Accessioned Date"
        values={{
          from: {
            id: "accessionCompletedAfter",
            name: "accession_completed_after",
            value: props.accessionCompletedAfter,
          },
          to: {
            id: "accessionCompletedBefore",
            name: "accession_completed_before",
            value: props.accessionCompletedBefore,
          },
        }}
        onChangeDate={props.onChangeDateRange}
        isClearable
      />
      <DateRangeInput
        id="finalizedAt"
        label="Finalized Date"
        values={{
          from: {
            id: "finalizedAtAfter",
            name: "finalized_at_after",
            value: props.finalizedAtAfter,
          },
          to: {
            id: "finalizedAtBefore",
            name: "finalized_at_before",
            value: props.finalizedAtBefore,
          },
        }}
        onChangeDate={props.onChangeDateRange}
        isClearable
      />
    </>
  );
};

export default DateRangeFilters;
